import { render, staticRenderFns } from "./EntregasLista.vue?vue&type=template&id=1714399f"
import script from "./EntregasLista.vue?vue&type=script&lang=js"
export * from "./EntregasLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports